{
    
    "apiKey": "839e15c5-b3dc-4adf-9a82-6d97c8ca004d",
    "noticeId": "fk9n2GTd",
    "sdkPath": "https://sdk.privacy-center.org/",
    "iabVersion": 2
}


